// extracted by mini-css-extract-plugin
module.exports = {"content":"M1ZK3CY6","upgradation":"G63YO3eR"};